/**
 * Builds a copy-pastable string from MSAL / Auth0-style errors (and generic Errors).
 * Popup windows often truncate Azure AD HTML; the thrown Error usually has the full text.
 */
export function formatAuthLibraryError(error) {
  if (error == null) return 'Unknown error'
  if (typeof error !== 'object') return String(error)

  const lines = []
  if (error.message) lines.push(String(error.message))
  if (error.errorCode) lines.push(`errorCode: ${error.errorCode}`)
  if (error.errorMessage && error.errorMessage !== error.message) {
    lines.push(String(error.errorMessage))
  }
  if (error.subError) lines.push(`subError: ${error.subError}`)
  if (error.correlationId) lines.push(`correlationId: ${error.correlationId}`)

  const text = lines
    .filter(Boolean)
    .join('\n')
    .trim()
  return text || String(error)
}
